import { create } from "zustand";

interface State {
  isOpen: boolean;
  // Concept to pre-select when the wizard opens (e.g. BuildBar / Curate
  // deep-links). Cleared on close so a subsequent global open() doesn't
  // inherit a stale concept.
  pendingConceptId: string | null;
}

interface Actions {
  open: (conceptId?: string) => void;
  close: () => void;
}

export const useZoteroBulkImportModalStore = create<State & Actions>((set) => ({
  isOpen: false,
  pendingConceptId: null,
  open: (conceptId?: string) =>
    set({ isOpen: true, pendingConceptId: conceptId ?? null }),
  close: () => set({ isOpen: false, pendingConceptId: null }),
}));
